import * as types from "../../actions/notifications/types";

const initialState = {
  notifications: [],
};

const ERROR = "error";
const SUCCESS = "success";

export default function userSegments(state = initialState, action) {
  switch (action.type) {
    case types.SHOW_ERROR_NOTIFICATION: {
      const notification = {
        id: action.id,
        message: action.message,
        type: ERROR,
      };

      return Object.assign({}, state, {
        notifications: [...state.notifications, notification],
      });
    }
    case types.SHOW_SUCCESS_NOTIFICATION: {
      const notification = {
        id: action.id,
        message: action.message,
        type: SUCCESS,
      };

      return Object.assign({}, state, {
        notifications: [...state.notifications, notification],
      });
    }
    case types.REMOVE_NOTIFICATION: {
      return Object.assign({}, state, {
        notifications: state.notifications.filter(
          notification => notification.id !== action.id
        ),
      });
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/notifications/index.js